import React from 'react';

interface TableProps {
  headers: string[];
  rows: React.ReactNode[];
}

const Table: React.FC<TableProps> = ({ headers, rows }) => (
  <div className="max-w-full rounded-2xl border border-neutral-200 overflow-y-hidden overflow-x-hidden max-h-[800px]">
    <table className="w-full text-base font-normal">
      <thead className="bg-neutral-100 border-b-1 border-neutral-200 sticky top-0">
        <tr>
          {headers.map((header) => (
            <th
              key={`table-${header}`}
              className="px-4 py-3 text-[#575757] text-xs font-bold whitespace-nowrap"
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows
        ) : (
          <tr>
            <td
              colSpan={headers.length}
              className="text-center font-normal text-base italic text-neutral-500 h-52"
            >
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default Table;
